import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const StyledTitle = styled(Typography)`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
`;

const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ToggleDescription = styled(Typography)`
  font-size: 14px;
  color: ${colors.shades.gamma10};
  margin-bottom: 12px;
`;

export {
  Container,
  StyledTitle,
  ToggleContainer,
  ToggleDescription,
};
